import axios from "../../axios";
import { toast } from "react-toastify";
import { ADD_HSN, DELETE_HSN, GET_HSN, UPDATE_HSN, GET_ONE_HSN} from "../types";

export const getHsn = (params) => async (dispatch) => {
    try {
      const res = await axios.get('/hsn/all', {params});
  
      if (res.data.code === 1) {
        dispatch({ type: GET_HSN, payload: res.data.data });
      } 
    } catch (err) {
      if(err.response.data.errors[0].message){
        toast.error(err.response.data.errors[0].message);
      }
      // console.error("Failed to get Hsn. Please try again. :", err);
    }
};

export const addHsn = (formData) => async (dispatch) => {
    try {
      const res = await axios.post('/hsn/add', formData);
  
      if (res.data.code === 1) {
        dispatch({ type: ADD_HSN, payload: res.data.data });
        setTimeout(() => {
          toast.success("Hsn added successfully!");
        }, 1000);
      } 
      if (res.data.code === 0) {
        setTimeout(() => {
          toast.error(res.data.message);
        }, 1000);
      } 
    } catch (err) {
      if(err.response.data.errors[0].message){
        toast.error(err.response.data.errors[0].message);
      }
    }
};

export const updateHsn = (formData) => async (dispatch) => {
    try {
      const res = await axios.post(`/hsn/update`, formData);
  
      if (res.data.code === 1) {
        dispatch({ type: UPDATE_HSN, payload: res.data.data });
     
        setTimeout(() => {
          toast.success("Hsn updated successfully!");
        }, 1000);
      } 
    } catch (err) {
      if(err.response.data.errors[0].message){
        toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to update Hsn. Please try again.");
    }
};

// Delete Hsn
export const deleteHsn = (id) => async (dispatch) => {
  try {
    if(!id){
      toast.error("Please select any record");
      return false;
    }
    const res = await axios.post(`/hsn/delete/${id}`);
    if (res.data.code === 1) {
        dispatch({ type: DELETE_HSN, payload: {id} });
        setTimeout(() => {
          toast.success("Hsn deleted successfully!");
        }, 1000);
      } 
  } catch (err) {
    if(err.response.data.errors[0].message){
      toast.error(err.response.data.errors[0].message);
    }
    // toast.error("Failed to delete Hsn. Please try again.");
  }
};

export const getSingleHsn = (id) => async (dispatch) => {
  try {
    const res = await axios.get(`/hsn/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: GET_ONE_HSN, payload: res.data.data });
    }
  } catch (err) {
    console.error('Failed to get item by finish item. Please try again.');
    if (err.response.data.message) {
      toast.error(err.response.data.message);
    }
  }
};